import { atom } from 'jotai';

export const resignModalAtom = atom({
  isOpen: false
});
